<template>
  <div class="legend">
    <template v-for="_legend in data">
      <span
        v-if="_legend.backgroundColor"
        :key="_legend.label"
        :style="{
          '--background-color': _legend.backgroundColor || white
        }"
        >{{ _legend.label }}</span
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.legend {
  margin: 5px 15px;
  width: auto;
  display: block;
  > span {
    &::before {
      content: "";
      display: inline-block;
      width: 30px;
      height: 10px;
      margin-right: 5px;
      background-color: var(--background-color);
    }
    display: inline-block;
    text-transform: capitalize;
    font-size: 0.8em;
    height: 1.3em;
    margin-right: 15px;
  }
}
</style>
